import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationLoadReadService,
  AdminLoadBoardModel,
  LoadBoardRequest,
  AnyValueModelString,
  AdminLoadModel,
  PageModelAdminLoadListModel,
  AdminLoadListRequest,
  AdminLoadListModel,
  PriceModel,
  CustomerPricePredictionRequest
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationLoadReadApiService {
  constructor(private apiService: AdministrationLoadReadService) {}

  public loadBoard(body: LoadBoardRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadBoardModel[]> {
    return this.apiService.adminLoadBoard(body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public generateNumber(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelString> {
    return this.apiService.adminLoadGenerateNumber(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getLoad(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadGet(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listLoads(body: AdminLoadListRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelAdminLoadListModel> {
    return this.apiService.adminLoadList(body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getLoadListModel(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadListModel> {
    return this.apiService.adminLoadListModelGet(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public predictPrice(body: CustomerPricePredictionRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PriceModel> {
    return this.apiService.adminLoadPredictPrice(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
